import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { getConfiguration } from '@lx/shared/tokens';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabViewModule } from 'primeng/tabview';
import { TreeModule } from 'primeng/tree';
import { Observable } from 'rxjs';
import { CompanyEnum } from '../../models/company.model';
import { PriceListArea } from '../../models/pricelist-area.model';
import { PriceListsTabsService } from '../../services/price-lists-tabs.service';
import { SharedDataStore } from '../../store';
import { ViewMode } from '../../utils/view-mode';
import { JuniorCampsComponent } from '../junior-camps/junior-camps.component';
import { OnlineCoursesComponent } from '../online-courses/online-courses.component';
import { PriceListsComponent } from '../price-lists/price-lists.component';
import { PriceListsHeaderComponent } from '../pricelists-header/pricelists-header.component';
import { PrintablePriceListsComponent } from '../printable-pricelists/printable-pricelists.component';
import { AcademicYearAbroadComponent } from '../academic-year-abroad/academic-year-abroad.component';
import { YoungAdultsComponent } from '../young-adults/young-adults.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-price-lists-portal',
  imports: [
    CommonModule,
    TabViewModule,
    ProgressSpinnerModule,
    PriceListsComponent,
    OnlineCoursesComponent,
    TreeModule,
    PrintablePriceListsComponent,
    PriceListsHeaderComponent,
    JuniorCampsComponent,
    AcademicYearAbroadComponent,
    YoungAdultsComponent,
  ],
  templateUrl: './pricelists-portal.component.html',
  styleUrls: ['./pricelists-portal.component.scss'],
})
export class PriceListsPortalComponent implements OnInit {
  CompanyEnum = CompanyEnum;
  ViewMode = ViewMode;
  currentViewMode = ViewMode.SCREEN;
  priceListArea$: Observable<PriceListArea> | undefined;
  selectedTabIndex = 0;

  screenModeButtons = [];
  printModeButtons = [];
  priceListShowJuniorCamps: string | boolean = false;
  priceListShowAya: string | boolean = false;
  priceListShowYoungAdults: string | boolean = false;

  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly viewPort = inject(ViewportScroller);
  private readonly configuration = getConfiguration();
  private readonly priceListsTabsService = inject(PriceListsTabsService);

  constructor() {
    this.screenModeButtons = [
      {
        name: 'Printable Version',
        action: () => {
          this.showPrintableMode();
        },
      },
    ];

    this.printModeButtons = [
      {
        name: 'Print',
        action: () => {
          setTimeout(() => {
            window.print();
          }, 20);
        },
      },
      {
        name: 'Cancel',
        action: () => {
          this.showScreenMode();
        },
      },
    ];
  }

  ngOnInit(): void {
    this.priceListArea$ = this.sharedDataStore.priceListArea$;
    this.priceListShowJuniorCamps = this.configuration.PRICE_LIST_SHOW_JUNIOR_CAMPS;
    this.priceListShowAya = this.configuration.PRICE_LIST_SHOW_AYA;
    this.priceListShowYoungAdults = this.configuration.PRICE_LIST_SHOW_YOUNG_ADULTS;
  }

  onChangeTab() {
    this.scrollToTop();
    this.priceListsTabsService.updateCompanyForTab(this.selectedTabIndex);
  }

  private showPrintableMode() {
    this.currentViewMode = ViewMode.PRINT;
    this.sharedDataStore.updateCompany(CompanyEnum.KIL);
  }

  private showScreenMode() {
    this.currentViewMode = ViewMode.SCREEN;
    // After switching back to screen mode, we need to update the company based on the selected tab index
    this.priceListsTabsService.updateCompanyForTab(this.selectedTabIndex);
  }

  private scrollToTop() {
    this.viewPort.scrollToPosition([0, 0]);
  }
}
